import React from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { Controller } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration from "../../../../util/EditorConfiguration";

const EmailTemplateSubmissionForm = (props) => {
  const {
    type,
    suffix,
    initialValues,
    handleSubmit,
    onSubmit,
    control,
    classes,
    disabled,
  } = props;
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">
          Redemption {type} Email Content (English)
        </Typography>
      </Box>

      <Grid item xs={12}>
        <Controller
          name={`contentEN_${suffix}`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <CKEditor
              editor={Editor}
              config={editorConfiguration}
              data={field.value}
              disabled={disabled}
              onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
                console.log("Editor is ready to use!", editor);
                editor &&
                  editor.setData(
                    editor.getData() || initialValues[`contentEN_${suffix}`]
                  );
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                field.onChange(data);
                // console.log({ event, editor, data });
              }}
              onBlur={(event, editor) => {
                console.log("Blur.", editor);
              }}
              onFocus={(event, editor) => {
                console.log("Focus.", editor);
              }}
            />
          )}
        />
      </Grid>

      <Box fontWeight={900} fontSize={13} mt={4} mb={2} width="100%">
        <Typography variant="p">
          Redemption {type} Email Content (Traditional Chinese)
        </Typography>
      </Box>

      <Grid item xs={12}>
        <Controller
          name={`contentTC_${suffix}`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <CKEditor
              editor={Editor}
              config={editorConfiguration}
              data={field.value}
              disabled={disabled}
              onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
                console.log("Editor is ready to use!", editor);
                editor &&
                  editor.setData(
                    editor.getData() || initialValues[`contentTC_${suffix}`]
                  );
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                field.onChange(data);
                // console.log({ event, editor, data });
              }}
              onBlur={(event, editor) => {
                console.log("Blur.", editor);
              }}
              onFocus={(event, editor) => {
                console.log("Focus.", editor);
              }}
            />
          )}
        />
      </Grid>

      {disabled || (
        <div className={classes.buttonGroup}>
          <Button
            type="submit"
            variant="contained"
            disableElevation
            style={{
              color: "white",
              background: "#306F9D",
              marginRight: "5px",
              padding: "9px 16px",
            }}
          >
            Save
          </Button>
        </div>
      )}
    </form>
  );
};

export default EmailTemplateSubmissionForm;
